const ADDRESSES = [
  ["info@mjp-offer.nl", "Afzender van je campagnemails (kolom Afzender in CSV en Verzendhulp)"],
  ["admin@mjp-offer.nl", "Alleen je inlognaam voor de app — hier komt geen mail op binnen"],
  ["mailserver-mjp.com", "Geen mailbox: webadres achter de afmeldlink"],
  ["app.meerjarenplanonline.nl", "De proeflink in je mails (met UTM-tags)"],
];
const INBOUND = [
  ["Reacties van verenigingen", "info@mjp-offer.nl", "Klik in de tabel op Reageerde of Klant geworden"],
  ["Bounces (onbestelbaar)", "Outlook-account van je add-on", "Lead op Gepauzeerd zetten of e-mail verwijderen"],
  ["Afmeldingen", "Geen mail — gaat automatisch", "Niets"],
  ["Afwezigheidsmeldingen", "info@mjp-offer.nl", "Negeren"],
];

const MiniTable = ({ head, rows, testid }) => (
  <div className="overflow-x-auto">
    <table data-testid={testid} className="w-full text-sm">
      <thead><tr className="text-left text-xs uppercase tracking-wide text-slate-400">{head.map((h) => <th key={h} className="py-1 pr-3 font-semibold">{h}</th>)}</tr></thead>
      <tbody>{rows.map((r) => (
        <tr key={r[0]} className="border-t border-slate-100 align-top">
          {r.map((c, i) => <td key={i} className={`py-1.5 pr-3 ${i === 0 ? "font-medium text-slate-900 whitespace-nowrap" : "text-slate-600"}`}>{c}</td>)}
        </tr>
      ))}</tbody>
    </table>
  </div>
);

const MailAddresses = () => (
  <div data-testid="mail-addresses" className="mt-5 rounded-lg border border-slate-200 bg-white p-5">
    <h3 className="font-display text-lg font-bold text-slate-900">E-mailadressen: wat komt waar binnen?</h3>
    <p className="mt-1 text-sm text-slate-500">De app verstuurt en ontvangt zelf geen mail — alles loopt via je eigen Outlook.</p>
    <h4 className="mt-4 mb-1 text-sm font-semibold text-[#FF4500]">Adressen die de app gebruikt</h4>
    <MiniTable testid="mail-addresses-used" head={["Adres", "Waarvoor"]} rows={ADDRESSES} />
    <h4 className="mt-4 mb-1 text-sm font-semibold text-[#FF4500]">Wat moet waar binnenkomen</h4>
    <MiniTable testid="mail-addresses-inbound" head={["Wat", "Komt binnen op", "Jij doet"]} rows={INBOUND} />
    <div className="mt-4 rounded-md bg-amber-50 p-3 text-sm text-amber-900 space-y-1">
      <p><strong>Controleer eenmalig:</strong></p>
      <p>1. Je Outlook-add-on verstuurt vanaf <strong>info@mjp-offer.nl</strong> (zelfde als kolom Afzender).</p>
      <p>2. info@mjp-offer.nl is een echte mailbox die je leest (of doorstuurt).</p>
      <p>3. Open één afmeldlink uit een CSV: zie je een bevestigingspagina, dan werkt het.</p>
    </div>
  </div>
);

const ROUNDS = [
  {
    title: "Voorbereiding (eenmalig na een deploy)",
    steps: [
      "Log in op de live-app.",
      "Nieuwe leads gescraped in de preview? Klik rechtsboven op Synchroniseren.",
    ],
  },
  {
    title: "Ronde 1 — Mail 1",
    steps: [
      "Open de ledentabel (bijv. Watersportverenigingen), eventueel met filter 'Alleen met e-mail'.",
      "Klik op de kolomkop Verzonden: wie nog niets kreeg staat onderaan (—).",
      "Vink de gewenste contacten aan.",
      "Kies Mail 1 in het keuzemenu naast 'CSV voor selectie' en klik op de knop.",
      "De CSV wordt gedownload én de contacten staan meteen op 'Mail 1 verzonden'. Toch niet versturen? Klik 'Ongedaan maken' in de melding of bij 'Laatste export' in CRM & mailen.",
      "Importeer de CSV in je Outlook-add-on (kolommen Onderwerp, Bericht/HTML, Afmeldlink) en verstuur.",
    ],
  },
  {
    title: "Ronde 2 — Mail 2 (± 4 dagen later)",
    steps: [
      "Sorteer op Verzonden: je ziet wie 'Mail 1' kreeg en wanneer.",
      "Vink die contacten aan — te veel aanvinken mag, wie niet aan de beurt is wordt overgeslagen.",
      "Kies Mail 2 → CSV voor selectie → versturen via de add-on.",
    ],
  },
  {
    title: "Ronde 3 — Mail 3 (± 5 dagen na Mail 2)",
    steps: ["Zelfde werkwijze met Mail 3. Daarna is de reeks voor dat contact afgerond."],
  },
];

export const OutlookSteps = () => (
  <>
  <div data-testid="outlook-steps" className="mt-7 rounded-lg border border-orange-200 bg-orange-50/40 p-5">
    <h3 className="font-display text-lg font-bold text-slate-900">Route B — Versturen via je Outlook-add-on (CSV)</h3>
    <div className="mt-4 space-y-4">
      {ROUNDS.map((r) => (
        <div key={r.title}>
          <h4 className="text-sm font-semibold text-[#FF4500]">{r.title}</h4>
          <ol className="mt-1 list-decimal pl-5 text-sm text-slate-700 space-y-1 leading-relaxed">
            {r.steps.map((s) => <li key={s}>{s}</li>)}
          </ol>
        </div>
      ))}
    </div>
    <div className="mt-4 text-sm text-slate-700 space-y-1">
      <p><strong>Tussendoor:</strong> afmeldingen worden automatisch overgeslagen. Reageert iemand of wordt
        iemand klant, zet dat in <strong>CRM &amp; mailen</strong> — dan geen vervolgmails meer.</p>
      <p><strong>Tip:</strong> klik pas op OK als je de mails écht verstuurt. Iets misgegaan?
        Met <strong>Reset naar Mail 1</strong> in de CRM begin je opnieuw.</p>
    </div>
  </div>
  <MailAddresses />
  </>
);
